import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { ThreeDots } from "react-loader-spinner";
// import moment from "moment";
import { useHomeContext } from "../../context/HomeContext";
const Notification = () => {
  const { token, user } = useAuth();
  const {
    readNotificationId,
    readAllNotificationId,
    setReadNotificationId,
    setAllReadNotificationId,
  } = useHomeContext();
  console.log(readNotificationId);
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const allNotifications = useQuery(
    ["allNotificationDataApi"],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}notification/admin/${user._id}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {},
    }
  );
  //mark as read

  const markAsReadNotifications = useQuery(
    ["maRkAsReadNotificationDataApi", readNotificationId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}notification/mark/${readNotificationId}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!readNotificationId,
      onSuccess: (res) => {
        setReadNotificationId(null);
      },
    }
  );

  const markAllAsReadNotifications = useQuery(
    ["markAllAsReadNotificationDataApi", readAllNotificationId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}notification/admin/all/unread/${user._id}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!readAllNotificationId,
      onSuccess: (res) => {
        setAllReadNotificationId(null);
      },
    }
  );
  return (
    <div className="p-3 md:p-5 ">
      <div className="py-3">
        <nav className="flex" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <Link
                to="/"
                className="inline-flex items-center  font-medium text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
              >
                Dashboard
              </Link>
            </li>
            <li>
              <div className="flex items-center">
                <svg
                  className="w-6 h-6 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <span class="ml-1  font-medium text-gray-500 md:ml-2 dark:text-gray-400">
                  Notifications
                </span>
              </div>
            </li>
          </ol>
        </nav>
      </div>

      {/* faqs */}
      <div className="bg-white dark:bg-secondary-dark-bg p-2 md:p-5 rounded-lg">
        <h1 className="text-dark-color dark:text-white font-bold text-2xl pb-3">
          Notifications
        </h1>

        <div>
          <div className="w-full ">
            {allNotifications.isFetched ? (
              allNotifications?.data?.data?.data?.length > 0 ? (
                <div className="flex flex-col items-start space-y-2 w-full">
                  <div className="flex items-end justify-end self-end  w-full">
                    <button
                      onClick={() => setAllReadNotificationId(1)}
                      className="text-[13px] bg-blue-bg/50 rounded-full p-1 px-2"
                    >
                      Mark All As Read
                    </button>
                  </div>
                  {allNotifications?.data?.data?.data?.map((item) => (
                    <div
                      className="flex  items-start space-x-1 md:space-x-4 w-full h-[90px]
                   bg-main-bg rounded-lg dark:bg-[#292931]"
                    >
                      {item.readAt == null && (
                        <div className="bg-blue-bg w-2 h-full rounded-l-lg" />
                      )}
                      <div className="flex items-center h-20 justify-between w-full  px-3">
                        <div>
                          <h1 className="font-medium text-dark-color dark:text-gray-300 text-lg ">
                            {item.title}
                          </h1>
                          <p className=" text-dark-gray dark:text-gray-300 text-[14px]">
                            {item.message}
                          </p>
                        </div>

                        <div className="flex flex-col   justify-between items-end h-full pt-4">
                          {item.readAt == null && (
                            <button
                              onClick={() => setReadNotificationId(item._id)}
                              className="text-[13px]  bg-blue-bg/50 rounded-full p-1 px-2 items-start self-start"
                            >
                              Mark As Read
                            </button>
                          )}
                          <p className="text-[13px] whitespace-nowrap self-end justify-end flex text-end text-dark-gray dark:text-gray-300">
                            {/* {moment(item.createdAt).fromNow()} */}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="flex items-center justify-center text-center w-full">
                  <h1 className="font-medium text-dark-color dark:text-gray-300 text-lg ">
                    You Have No Notification
                  </h1>
                </div>
              )
            ) : (
              <div className="flex items-center justify-center">
                <ThreeDots
                  height="80"
                  width="80"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
